/*
 * File: index.tsx
 * Project: JobApp-Admin
 * File Created: Tuesday, 21st January 2020 12:39:53 am
 * Author: Umar Aamer (umaraamer@gmail.com)
 * -----
 * Last Modified: Wednesday, 12th January 2022 12:19:34 am
 * -----
 * Copyright 2020 - 2021 WhileGeek, https://umar.tech
 */

import React from "react";
import ReactDOM from "react-dom";
import reportWebVitals from "./reportWebVitals";
// import "./assets/styles/index.scss";
import "./assets/css/icomoon.css";
import "./assets/styles/index.scss";
import App from "./App";
// import * as serviceWorker from "./serviceWorker";
import "./Config/ReactotronConfig";
import { AppProvider } from "./Services/AppContext";

ReactDOM.render(
  <React.StrictMode>
    <AppProvider>
      <App />
    </AppProvider>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
